import { Dispatch } from "redux";
import {JackpotCreateActionTypes, JackpotCreateAction} from "../../types/Jackpot/jackpotCreateTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const createJackpot = (data: any): any => {
    return async (dispatch: Dispatch<JackpotCreateAction>) => {
        try {
            dispatch({ type: JackpotCreateActionTypes.FETCH_JACKPOT_CREATE_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/jackpots/create`,
                data: data,
                withCredentials: false
            });
            dispatch({ type: JackpotCreateActionTypes.FETCH_JACKPOT_CREATE_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: JackpotCreateActionTypes.FETCH_JACKPOT_CREATE_DATA_ERROR, payload: errorPayload });
        }
    }
}
